// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"68c9ccd6","445":"7807615a","582":"e8f4caa8","658":"84904891","741":"ec6e0906","875":"4780edd8"}[chunkId] + ".chunk.js";
};